var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13003_197036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13003_197036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 12.8C13.2147 12.8 12.5542 12.5272 12.0125 11.9816C11.4708 11.436 11.2 10.7735 11.2 9.99413C11.2 9.21471 11.4728 8.55417 12.0184 8.0125C12.564 7.47083 13.2265 7.2 14.0059 7.2C14.7853 7.2 15.4458 7.47279 15.9875 8.01837C16.5292 8.56397 16.8 9.22647 16.8 10.0059C16.8 10.7853 16.5272 11.4458 15.9816 11.9875C15.436 12.5292 14.7735 12.8 13.9941 12.8ZM7.3 15.8C6.75 15.8 6.2625 15.5875 5.8375 15.1625C5.4125 14.7375 5.2 14.25 5.2 13.7V6.1C5.2 5.55 5.4125 5.0625 5.8375 4.6375C6.2625 4.2125 6.75 4 7.3 4H20.9C21.45 4 21.9375 4.2125 22.3625 4.6375C22.7875 5.0625 23 5.55 23 6.1V13.7C23 14.25 22.7875 14.7375 22.3625 15.1625C21.9375 15.5875 21.45 15.8 20.9 15.8H7.3ZM9.3 13.7H18.9C18.9 13.15 19.0958 12.6792 19.4875 12.2875C19.8792 11.8958 20.35 11.7 20.9 11.7V8.1C20.35 8.1 19.8792 7.90417 19.4875 7.5125C19.0958 7.12083 18.9 6.65 18.9 6.1H9.3C9.3 6.65 9.10417 7.12083 8.7125 7.5125C8.32083 7.90417 7.85 8.1 7.3 8.1V11.7C7.85 11.7 8.32083 11.8958 8.7125 12.2875C9.10417 12.6792 9.3 13.15 9.3 13.7ZM3.1 20C2.5225 20 2.02813 19.7944 1.61688 19.3831C1.20563 18.9719 1 18.4775 1 17.9V8.04387C1 7.76462 1.10417 7.52083 1.3125 7.3125C1.52083 7.10417 1.76667 7 2.05 7C2.33333 7 2.57917 7.10417 2.7875 7.3125C2.99583 7.52083 3.1 7.76462 3.1 8.04387V17.9H18.9539C19.2346 17.9 19.4792 18.0042 19.6875 18.2125C19.8958 18.4208 20 18.6667 20 18.95C20 19.2333 19.8958 19.4792 19.6875 19.6875C19.4792 19.8958 19.2346 20 18.9539 20H3.1Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.c7d946095e75e1426f45533dc0de7f63.svg";
export { ForwardRef as ReactComponent };